/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nda_Status_Withgp2Inputs */

const en_coinvestments_nda_status_withgp2 = /** @type {(inputs: Coinvestments_Nda_Status_Withgp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With GP`)
};

/**
* | output |
* | --- |
* | "With GP" |
*
* @param {Coinvestments_Nda_Status_Withgp2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nda_status_withgp2 = /** @type {((inputs?: Coinvestments_Nda_Status_Withgp2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nda_Status_Withgp2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nda_status_withgp2(inputs)
});
export { coinvestments_nda_status_withgp2 as "coInvestments_nda_status_withGp" }